module.exports = __webpack_public_path__ + "static/media/fleeDashboardIcon.04e465be.svg";